(function(window, pipControllerFactoryFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.pipControllerFactory = pipControllerFactoryFactory(
      namespace.nullPipController,
      namespace.ChromePipController,
      namespace.SafariPipController,
      namespace.playerConfiguration);
})(this, function(nullPipController,
                  ChromePipController,
                  SafariPipController,
                  playerConfiguration) {
   'use strict';

   var getPipController = function(mediaElement) {
      if (!playerConfiguration.disablePictureInPicture && ChromePipController.isControllerSupported()) {
         return ChromePipController.create(mediaElement);
      } else if (!playerConfiguration.disablePictureInPicture && SafariPipController.isControllerSupported(mediaElement)) {
         return SafariPipController.create(mediaElement);
      }
      return nullPipController;
   };

   return {
      getPipController: getPipController
   };
});
